import { create } from 'zustand'

export interface Toast {
  id: number
  message: string
  variant: 'error' | 'success'
}

interface ToastState {
  toasts: Toast[]
  push: (message: string, variant?: Toast['variant']) => void
  dismiss: (id: number) => void
}

let nextId = 1

/**
 * Transient notifications. Backs the global mutation-error net (see queryClient) so no failed
 * write is ever completely silent, plus explicit success/error toasts from components.
 */
export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, variant = 'error') => {
    const id = nextId++
    set((s) => ({ toasts: [...s.toasts, { id, message, variant }] }))
    // Auto-dismiss; errors linger a little longer than successes.
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
      variant === 'error' ? 7000 : 4000)
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

/** Push a toast from non-React code (e.g. the react-query MutationCache error handler). */
export function pushToast(message: string, variant: Toast['variant'] = 'error'): void {
  useToastStore.getState().push(message, variant)
}
